<template>
  <v-flex xs12>
    <div v-if="show" class="text-xs-left">
      <v-flex xs12>
        <v-card v-if="hasNoContext">
          <v-form v-if="hasComps" ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-switch v-model="allUsers" :label="`Add All Users of ${natOrgObj.name}`"></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="!allUsers">
                    <v-autocomplete
                      v-model="emails"
                      :items="emailresults"
                      :loading="emailsLoading"
                      :search-input.sync="emailsearch"
                      :rules="emailRequired"
                      required
                      label="Select Users by Email"
                      hint="Start typing and select user to add"
                      return-object
                      persistent-hint
                      multiple
                      chips
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="selectedComps"
                      :items="comps"
                      :rules="compRequired"
                      required
                      attach
                      chips
                      label="Competitions"
                      multiple
                      hint="Select the competitions these users will be added to"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="submit">Add</v-btn>
            </v-card-actions>

            <v-layout row justify-center>
              <v-dialog v-model="dialog" scrollable persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Added Users</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text style="height: 300px;">
                    <p
                      v-if="selectedComps.length"
                    >Added selected users to {{selectedComps.length}} competitions</p>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="clear">Okay</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-form>
          <v-card-text v-else>
            <h4>This National Organization currently has no active competitions</h4>
          </v-card-text>
        </v-card>

        <v-card v-else>
          <v-card-text>
            <h4>Choose National Organization to manage users for:</h4>
            <template v-for="(item, key) in natOrgs">
              <router-link
                :key="key"
                :to="{name:'Add Org Users To Competitions', params: {noid:key}}"
              >
                {{item.name}}
                <br>
              </router-link>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <v-card v-else>Admins Only</v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
/*global firebase*/
export default {
  name: "AddUsersToCompetitions",
  data: () => ({
    hasNoContext: false,
    noid: "",
    allUsers: true,
    dialog: false,
    valid: true,
    selectedComps: [],
    emails: [],
    emailsLoading: false,
    emailresults: [],
    emailsearch: null,
    emailRequired: [v => (v ? v.length > 0 : false || "Required")],
    compRequired: [v => v.length > 0 || "Required"]
  }),
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["isAdmin", "isNorgAdmin", "natOrgs"]),
    show() {
      return this.isAdmin || this.isNorgAdmin;
    },
    natOrgObj() {
      return this.natOrgs[this.noid];
    },
    hasComps() {
      let _comps = this.comps;
      if (_comps) {
        return _comps.length > 0;
      }
      return false;
    },
    comps() {
      let nOcompetitions = this.$store.getters.competitionByNo(this.noid);
      if (nOcompetitions) {
        let currCompVals = Object.values(nOcompetitions);
        let actualComps = currCompVals.map(k => {
          return { key: k, val: this.$store.getters.competitions[k] };
        });
        //endDate: new Date(this.endDate + "T12:00:00").getTime(),
        let today = new Date().getTime();
        let validComps = actualComps.filter(c => c.val.endDate > today);
        return validComps.map(c => {
          return { text: c.val.name, value: c.key };
        });
      }
      return false;
    },
    selectedUids() {
      return this.emails.map(u => {return u.value})
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "init",
    emailsearch(val) {
      // Items have already been requested
      if (this.emailsLoading) return;
      this.emailsLoading = true;
      firebase
        .database()
        .ref(`/licenseinvites/${this.noid}`)
        .orderByChild("email")
        .startAt(val)
        .endAt(`${val}\uf8ff`)
        .once("value")
        .then(snap => {
          if (snap.exists()) {
            let vs = Object.values(snap.val());
            this.emailresults = vs
              .filter(v => v.accepted)
              .map(u => {
                return { text: u.email, value: u.uid };
              }).concat(this.emails)
          }
        })
        .finally(() => {
          this.emailsLoading = false;
        });
    }
  },
  methods: {
    init() {
      if (this.$route.params.noid) {
        this.noid = this.$route.params.noid;
        this.$store.dispatch("initNatOrg", this.noid);
        this.hasNoContext = true;
      } else {
        this.hasNoContext = false;
        this.$store.dispatch("initNatOrgs");
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        let obj = {
          noid: this.noid,
          all: this.allUsers,
          competitions: this.selectedComps,
          users: this.selectedUids,
          processed: false
        };
        firebase
          .database()
          .ref()
          .child("addtocomps")
          .push(obj);
        this.dialog = true;
      }
    },
    clear() {
      this.$refs.form.reset();
      this.dialog = false;
      this.emails = [];
      this.selectedComps = [];
    }
  }
};
</script>
